// SizeTabs.js
import React from "react";
import { Table } from "react-bootstrap";

const sizeData = [
  {
    product: "3001/3001CVC",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    product: "T-shirt-Women",
    sizes: ["S", "M", "L", "XL", "2XL"],
  },
  {
    product: "Unisex Adult HOODIES",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    product: "Unisex Adult Sweatshirt",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    product: "Youth Sweatshirt",
    sizes: ["S", "M", "L", "XL"],
  },
  {
    product: "Racerback",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
  },
  {
    product: "Women V neck",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
  },
  {
    product: "YOUTH/3001 Y t-shirt",
    sizes: ["S", "M", "L", "XL"],
  },
  {
    product: "TOODLER",
    sizes: ["2T", "3T", "4T", "5T"],
  },
  {
    product: "BABY ONE PIECE",
    sizes: ["3/6 MONTH", "6/12 MONTH", "12/18 MONTH", "18/24 MONTH"],
  },
  {
    product: "Comfort Colors 1717",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    product: "Crop Tank",
    sizes: ["S", "M", "L", "XL", "2XL"],
  },
];

const sizesFlat = sizeData.flatMap((p) => p.sizes);
const uniqueSizes = Array.from(new Set(sizesFlat));

const order = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];
const allSizes = [
  ...order,
  ...uniqueSizes.filter((s) => !order.includes(s)),
];


const normalData = sizeData.filter(
  (item) => item.product !== "Comfort Colors 1717"
);
const comfortData = sizeData.find(
  (item) => item.product === "Comfort Colors 1717"
);

const renderTable = (data, sizes, isSticky = true) => (
  <div
    style={{
      overflowX: "auto",
      overflowY: isSticky ? "auto" : "unset",
      maxHeight: isSticky ? "80vh" : "unset",
      marginBottom: "40px",
      position: "relative",
    }}
  >
    <Table bordered hover style={{ tableLayout: "fixed", width: "100%" }}>
      <thead>
        <tr>
          <th
            style={{
              position: isSticky ? "sticky" : "static",
              top: isSticky ? 0 : "unset",
              left: 0,
              zIndex: isSticky ? 3 : "auto",
              backgroundColor: "#fff",
              fontSize: "12px",
              fontWeight: "bold",
              textAlign: "center",
              minWidth: "300px",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            Product
          </th>
          {sizes.map((size) => (
            <th
              key={size}
              style={{
                position: isSticky ? "sticky" : "static",
                top: isSticky ? 0 : "unset",
                zIndex: isSticky ? 2 : "auto",
                fontSize: "11px",
                fontWeight: "bold",
                textAlign: "center",
                verticalAlign: "middle",
                backgroundColor: "#f9f9f9",
                borderBottom: "2px solid #ccc",
                minWidth: "100px",
                whiteSpace: "normal",
              }}
            >
              {size}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            <td
              style={{
                fontWeight: "bold",
                position: "sticky",
                left: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 1,
                minWidth: "300px",
                fontSize: "12px",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {row.product}
            </td>
            {sizes.map((size) => (
              <td
                key={size}
                style={{
                  backgroundColor: row.sizes.includes(size)
                    ? "#d6f5d6"
                    : "#fff",
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                {row.sizes.includes(size) ? "YES" : ""}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

const SizeTabs = () => {
  const comfortSizes = comfortData ? comfortData.sizes : [];
  return (
    <>
      {renderTable(normalData, allSizes, true)}
      {comfortData && renderTable([comfortData], comfortSizes, false)}
    </>
  );
};

export default SizeTabs;
